module.exports = __webpack_public_path__ + "static/image/meituan.png?9f5ff48ee53d287a502ec75249c8f8a7";